import { CREDENTIAL_STRING_ID } from 'src/constants/localization';

export interface ComingSoonSection {
  /** Credential-bundle string id for the section title. */
  titleStringId: string;
  /** Credential-bundle string id for the section description. */
  descriptionStringId: string;
}

/**
 * Coming-soon teaser sections rendered, disabled, below a credential's live section. The M1 slim
 * backend does not model future sections, so the pilot declares them per credential here; a later
 * API-driven source can replace this map without changing the rendering component.
 */
export const CREDENTIAL_COMING_SOON_SECTIONS: Record<string, ComingSoonSection[]> = {
  'amazon-pricing-credential': [
    {
      titleStringId: CREDENTIAL_STRING_ID.COMING_SOON_PRICING_201_TITLE,
      descriptionStringId: CREDENTIAL_STRING_ID.COMING_SOON_PRICING_201_DESCRIPTION,
    },
    {
      titleStringId: CREDENTIAL_STRING_ID.COMING_SOON_PRICING_301_TITLE,
      descriptionStringId: CREDENTIAL_STRING_ID.COMING_SOON_PRICING_301_DESCRIPTION,
    },
  ],
};
